import {
  formattedTimeToSeconds,
  secondsToFormattedTime,
} from '@/core/utils/utils';
import { Options } from 'vue-class-component';
import ThermoPreferenceComponent from '../ThermoPreferenceComponent';

@Options({
  name: 'PreferenceCirculationPumpDelay',
  watch: {
    delayHeatingPumps: function (newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.delayHeatingPumps = secondsToFormattedTime(newValue);
    },
    delayCoolingPumps: function (newValue, oldValue) {
      if (!oldValue) return;
      this.roomObject.delayCoolingPumps = secondsToFormattedTime(newValue);
    },
  },
})
export default class PreferenceCirculationPumpDelay extends ThermoPreferenceComponent {
  delayHeatingPumps = 0;
  delayCoolingPumps = 0;

  mounted() {
    if (this.roomObject.delayCoolingPumps !== '00:00:00') {
      this.delayCoolingPumps = formattedTimeToSeconds(
        this.roomObject.delayCoolingPumps as string
      );
    }

    if (this.roomObject.delayHeatingPumps !== '00:00:00') {
      this.delayHeatingPumps = formattedTimeToSeconds(
        this.roomObject.delayHeatingPumps as string
      );
    }
  }
}
